const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_CAPEX_PLANNING",
    modulePath: "hml-new-netsuite.capex",
    moduleName: "capex",
    language: "pt",
    port: 8087,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
